import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";
import ContactForm from "../components/ContactForm";
import { FOR_SALE_DEALS, BRAND } from "../mock";
import { Phone, Tag } from "lucide-react";

export default function ForSale() {
  return (
    <>
      <Header />

      <section className="relative bg-[#f5a623] py-16">
        <div className="max-w-7xl mx-auto px-6">
          <span className="inline-block bg-[#0a0a0a] text-[#f5a623] px-3 py-1.5 text-[11px] font-bold tracking-[0.18em] mb-4">
            FRESH DEALS • UPDATED WEEKLY
          </span>
          <h1 className="display-font text-5xl md:text-7xl font-bold text-[#0a0a0a] max-w-3xl leading-[0.95]">
            For Sale Now.
          </h1>
          <p className="text-[#0a0a0a]/80 text-lg mt-3 max-w-2xl">
            In-stock builds, demo units, and overruns — priced to move. Call to lock yours.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {FOR_SALE_DEALS.map((d, i) => (
            <Reveal key={d.title} delay={i * 100}>
              <div className="bg-white border border-[#e6e6e6] overflow-hidden group hover:border-[#f5a623] transition-colors">
                <div className="relative h-64 overflow-hidden">
                  <img src={d.img} alt={d.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <span className="absolute top-3 left-3 bg-[#0a0a0a] text-[#f5a623] px-3 py-1 text-[10px] font-bold tracking-[0.18em]">{d.tag}</span>
                </div>
                <div className="p-6">
                  <h3 className="display-font text-xl font-bold mb-2">{d.title}</h3>
                  <div className="flex items-center justify-between">
                    <span className="display-font text-2xl font-bold text-[#f5a623]">{d.price}</span>
                    <a href={BRAND.phoneHref} className="inline-flex items-center gap-2 text-sm font-semibold hover:text-[#f5a623] transition-colors">
                      <Phone className="w-4 h-4" /> Call
                    </a>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="max-w-3xl mx-auto px-6 mt-16 text-center">
          <Tag className="w-8 h-8 text-[#f5a623] mx-auto mb-3" />
          <h3 className="display-font text-2xl md:text-3xl font-bold mb-2">Looking for something specific?</h3>
          <p className="text-[#555] mb-5">Inventory changes weekly. Drop us a line — we’ll match the build to your budget.</p>
          <a href={BRAND.phoneHref} className="inline-flex items-center gap-2 btn-amber px-7 py-3.5 font-bold uppercase tracking-wider text-sm">
            <Phone className="w-4 h-4" /> {BRAND.phone}
          </a>
        </div>
      </section>

      <ContactForm />
      <Footer />
    </>
  );
}
